module.exports = __webpack_public_path__ + "static/media/placeholder.5aba62a2.png";